import type { TFunction } from 'i18next';

import countries from 'i18n-iso-countries';
import eng from 'i18n-iso-countries/langs/en.json';
import pl from 'i18n-iso-countries/langs/pl.json';
import { all as AllCountries } from 'iso-3166-1';

export interface OnboardingModalOptions {
  workType: { label: string; value: string }[];
  occupation: { label: string; value: string }[];
  countries: { label: string; value: string }[];
}

export const getOnboardingModalOptions = (
  t: TFunction,
  language: string,
): OnboardingModalOptions => {
  countries.registerLocale(eng);
  countries.registerLocale(pl);
  return {
    countries: AllCountries().map((country) => ({
      label:
        countries.getName(country.alpha3, language, { select: 'official' }) ||
        country.country,
      value: country.alpha3,
    })),
    workType: [
      {
        value: 'Developer',
        label: t('AdditionalDataModal.WorkType.Developer'),
      },
      {
        value: 'Digital marketer',
        label: t('AdditionalDataModal.WorkType.DigitalMarketer'),
      },
      {
        value: 'Content specialist',
        label: t('AdditionalDataModal.WorkType.ContentSpecialist'),
      },
      {
        value: 'SEO specialist',
        label: t('AdditionalDataModal.WorkType.SeoSpecialist'),
      },
      {
        value: 'UX/UI designer',
        label: t('AdditionalDataModal.WorkType.UxUiDesigner'),
      },
      {
        value: 'Project manager',
        label: t('AdditionalDataModal.WorkType.ProjectManager'),
      },
    ],
    occupation: [
      {
        value: 'Digital Agency',
        label: t('AdditionalDataModal.Occupation.DigitalAgency'),
      },
      {
        value: 'Marketing / Communications',
        label: t('AdditionalDataModal.Occupation.MarketingCommunications'),
      },
      {
        value: 'Media / Publishing',
        label: t('AdditionalDataModal.Occupation.MediaPublishing'),
      },
      {
        value: 'Software development',
        label: t('AdditionalDataModal.Occupation.SoftwareDevelopment'),
      },
      {
        value: 'E-commerce / Retail',
        label: t('AdditionalDataModal.Occupation.ECommerceRetail'),
      },
      {
        value: 'Education / Learning',
        label: t('AdditionalDataModal.Occupation.EducationLearning'),
      },
      {
        value: 'Non-profit / NGO',
        label: t('AdditionalDataModal.Occupation.NonProfitNgo'),
      },
    ],
  };
};
